import { Array } from 'effect'
import { t } from 'i18next'

import type { CoreModel } from '../../schemas/model/model.ts'
import type { ModelProperty } from '../../schemas/model/modelProperty.ts'
import { SALESCORE_USER_MODEL } from './SALESCORE_USER_MODEL.ts'

export const SALESCORE_USER_WITH_GROUP_MODEL: CoreModel = {
  icon: 'faUsers',
  name: 'salescore_users_with_group',
  label: 'ユーザー',
  deletable: false,
  properties: [
    ...SALESCORE_USER_MODEL.properties,
    ...Array.range(1, 5).flatMap((index): ModelProperty[] => [
      {
        name: `user_group_d${index}_id`,
        type: 'string' as const,
        label: `グループID(階層${index})`, // 上書きしたい
        // meta: 'id', // idにしたいが、idではない
      },
      {
        name: `user_group_d${index}_name`,
        type: 'string' as const,
        label: `グループ名(階層${index})`, // 上書きしたい
        // meta: '', // nameにしたいが、nameではない
      },
    ]),
  ],
}

export function getSalescoreUserWithGroupModel(userGroupCategoryNames: string[]): CoreModel {
  return {
    ...SALESCORE_USER_WITH_GROUP_MODEL,
    properties: [
      ...SALESCORE_USER_MODEL.properties,
      ...Array.range(0, 4).flatMap((index): ModelProperty[] => [
        {
          name: `user_group_d${index + 1}_id`,
          type: 'string' as const,
          label: userGroupCategoryNames[index] ?? t(`グループ${index + 1}`),
          // meta: 'id', // idにしたいが、idではない
        },
        {
          name: `user_group_d${index + 1}_name`,
          type: 'string' as const,
          label: userGroupCategoryNames[index] ?? t(`グループ${index + 1}`),
          // meta: '', // nameにしたいが、nameではない
        },
      ]),
    ],
  }
}
